module.exports = __webpack_public_path__ + "static/media/chess.0a177083.png";